// ADMIN_AUTH đã bỏ — login qua API
export const ADMIN_AUTH = { username: '', password: '' } as const

export const ADMIN_STORAGE_KEY = 'xedien.admin.auth.v1'

export interface AdminNavItem {
  to: string
  label: string
  icon: string
  end?: boolean
}

export const ADMIN_NAV: AdminNavItem[] = [
  { to: '/admin',            label: 'Dashboard',  icon: 'layout-dashboard', end: true },
  { to: '/admin/san-pham',   label: 'Sản phẩm',   icon: 'package' },
  { to: '/admin/danh-muc',   label: 'Danh mục',   icon: 'folder-tree' },
  { to: '/admin/don-hang',   label: 'Đơn hàng',   icon: 'shopping-bag' },
  { to: '/admin/khuyen-mai', label: 'Khuyến mãi', icon: 'gift' },
  { to: '/admin/voucher',    label: 'Voucher',    icon: 'ticket' },
  { to: '/admin/tin-tuc',    label: 'Bài viết',   icon: 'newspaper' },
  { to: '/admin/chuyen-muc-tin-tuc', label: 'Chuyên mục TT', icon: 'newspaper' },
  { to: '/admin/cai-dat',    label: 'Cài đặt',    icon: 'settings' },
]
